import AddIcon from "@mui/icons-material/Add";
import { Button, Grid } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { AsyncSelectValue } from "@/components/AsyncSelect";
import AsyncSelectScroll from "@/components/AsyncSelectScroll";
import { DGT_Pagination } from "@/utils/utils";

export interface TemplateSelectRowProps {
  isLoading: boolean;
  value?: AsyncSelectValue | null;
  options?: AsyncSelectValue[];
  onSearch: (value: string) => void;
  onChange: (value: AsyncSelectValue | null) => void;
  onAdd: () => void;
  pagination: DGT_Pagination;
  setPagination: Dispatch<SetStateAction<DGT_Pagination>>;
  totalElements?: number;
}

const TemplateSelectRow = ({
  isLoading,
  value,
  options,
  onSearch,
  onChange,
  onAdd,
  pagination,
  setPagination,
  totalElements,
}: TemplateSelectRowProps) => (
  <Grid container spacing={1}>
    <Grid item xs={11}>
      <AsyncSelectScroll
        loading={isLoading}
        placeholder="Select Template"
        value={value}
        options={options}
        onSearch={onSearch}
        onChange={onChange}
        pagination={pagination}
        setPagination={setPagination}
        totalElements={totalElements}
      />
    </Grid>
    <Grid item xs={1}>
      <Button
        aria-label="Add template"
        sx={{ marginLeft: 0.5, marginTop: 1 }}
        variant="contained"
        onClick={onAdd}
      >
        <AddIcon />
      </Button>
    </Grid>
  </Grid>
);

export default TemplateSelectRow;
